import React from 'react';

export const globalDispatchContextDefaults = {
	toggleMenuState: (opened) => {},
	toggleMenuUpdate: (progress) => {},
	openAccordionItem: (anchor) => {},
};

export const GlobalDispatchContext = React.createContext(
	globalDispatchContextDefaults
);

export default GlobalDispatchContext;
